(function () {
  if (window.tgAjaxCartLoaded) return;
  window.tgAjaxCartLoaded = true;

  function getShopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function updateCartCounters(itemCount) {
    document.querySelectorAll('.tg-mobile-cart-count').forEach(function (el) {
      el.textContent = itemCount;
    });

    document.querySelectorAll('.tg-sidebar-cart-link span').forEach(function (el) {
      if (el.textContent.trim().toLowerCase().startsWith('winkelwagen')) {
        el.textContent = 'Winkelwagen (' + itemCount + ')';
      }
    });

    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
      el.textContent = itemCount;
    });
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;

    if (isLoading) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    } else {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  function showAddedFeedback(button) {
    if (!button) return;

    button.classList.add('tg-cart-added');
    button.setAttribute('title', 'Toegevoegd aan winkelwagen');

    window.setTimeout(function () {
      button.classList.remove('tg-cart-added');
      button.removeAttribute('title');
    }, 1200);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    if (form.hasAttribute('data-no-ajax-cart')) return;

    event.preventDefault();

    var root = getShopifyRoot();
    var submitButton = form.querySelector('[type="submit"]');
    var formData = new FormData(form);

    setButtonLoading(submitButton, true);

    fetch(root + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorData) {
            throw errorData;
          });
        }
        return response.json();
      })
      .then(function () {
        return fetch(root + 'cart.js', {
          headers: {
            'Accept': 'application/json'
          }
        });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCartCounters(cart.item_count);
        showAddedFeedback(submitButton);
      })
      .catch(function (error) {
        var message = 'Dit product kon niet worden toegevoegd aan de winkelwagen.';

        if (error && error.description) {
          message = error.description;
        } else if (error && error.message) {
          message = error.message;
        }

        alert(message);
      })
      .finally(function () {
        setButtonLoading(submitButton, false);
      });
  });
})();